import { render, staticRenderFns } from "./VoilaImageWithWireframe.vue?vue&type=template&id=35826908&"
import script from "./VoilaImageWithWireframe.vue?vue&type=script&lang=js&"
export * from "./VoilaImageWithWireframe.vue?vue&type=script&lang=js&"
import style0 from "./VoilaImageWithWireframe.vue?vue&type=style&index=0&id=35826908&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports